import React from "react";
import { Table } from "antd";

const CommonAdminTable = (props) => (
  <div className="max-w-full overflow-x-scroll">
    <Table
      className="rounded-lg"
      columns={props.columns}
      dataSource={props.data}
      size="middle"
      pagination={false}
      bordered
    />
  </div>
);
export default CommonAdminTable;
